import { Capacitor } from '@capacitor/core';

export const isNative = () => {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
};

export const isAndroid = () => {
  try { return Capacitor.getPlatform() === 'android'; } catch { return false; }
};

export const isIOS = () => {
  try { return Capacitor.getPlatform() === 'ios'; } catch { return false; }
};
